import { OrderByDto } from '@models/common/OrderByDto';
import { Type } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

type CustomDataMapper = (row: any) => any;

export class TableField {
    public name: string;
    public label: string;
    public pipe?: string;
    public format?: string;
    public componentName?: Type<any>;
    public componentData: CustomDataMapper = (row: any) => {
      return { row };
    };
    public iconIf?: string; // show icon in this tring if field [name] is true
    public checkbox?: boolean;
    public onCheckboxChange?: (row: any, value: boolean) => void;
    public checkboxDisabledIf?: (row: any) => boolean;
    public sortable?: boolean;
    public maxWidth?: string = 'auto';

    constructor(
        name: string,
        label: string,
        pipe?: string,
        format?: string,
        componentName?: Type<any>,
        componentData?: CustomDataMapper,
        iconIf?: string,
        sortable?: boolean,
        maxWidth?: string,
        checkbox?: boolean,
        onCheckboxChange?: (row: any, value: boolean) => void,
        checkboxDisabledIf?: (row: any) => boolean,
    ) {
        this.name = name;
        this.label = label;
        this.pipe = pipe;
        this.format = format;
        this.componentName = componentName;
        if (componentData) {
          this.componentData = componentData;
        }
        this.iconIf = iconIf;
        this.checkbox = checkbox;
        this.onCheckboxChange = onCheckboxChange;
        this.checkboxDisabledIf = checkboxDisabledIf;
        this.sortable = sortable;
        if (maxWidth) {
          this.maxWidth = maxWidth;
        }
    }
}

export class TableGroupAction {
  constructor(
    public name: string, // must be unique
    public label?: string,
    public tableActions?: TableAction[],
    public showSelectedBadge?: boolean,
    public showIf?: (row?: any) => boolean,
    public disabledIf?: (row?: any) => boolean,
  ) {}
}

export class TableAction {
  constructor(
    public name: string, // must be unique
    public onClick: (row?: any) => void,
    public label?: string,
    public labelParams?: any,
    public tooltip?: string,
    public tooltipPosition?: TooltipPosition,
    public icon?: string,
    public imageName?: string,
    public defaultImage?: string,
    public showIf?: (row?: any) => boolean,
    public disabledIf?: (row?: any) => boolean,
    public buttonActive?: () => boolean, 
    public actionClass?: string, // CSS class for the action button
  ) {}
}

export class TableSelectOptionAction {
  constructor(
    public name: string, // must be unique
    public label?: string,
    public options?: TableSelectOption[],
    public multiple?: boolean,
    public showIf?: () => boolean,
    public disabledIf?: () => boolean,
    public onSelectOption?: (options: undefined | TableSelectOption | TableSelectOption[]) => void,    
    public width?: string, // CSS width for the action column
  ) {}
}

export class CustomizableFields {
  constructor(
    public configName: string,
    public allFields: TableField[],
    public defaultFields: string[],
  ) {}
}

export class TableConfig {
  constructor(
    public fields: TableField[],
    // rowActions go in each row at the end of the row
    public rowActions: TableAction[],
    // tableFilters go on the left side of the table header with button toggle style
    public tableFilters?: TableAction[],
    // tableFilters go on the left side of the table header with <select> style
    public tableFilterOptionsGroup?: TableSelectOptionAction[],
    // tableGroupActions go before of tableActions on the table header
    public tableGroupActions?: TableGroupAction[],
    // tableActions go on the right side of the table header
    public tableActions?: TableAction[],
    // fabActions go in the floating action button on the bottom right of the table
    public fabActions?: TableAction[],
    public childName?: string,
    public childConfig?: TableConfig,
    public selectable?: boolean,
    public onSelect?: (row: any, selected: boolean) => void,
    public customizable?: CustomizableFields,
    public draggableRows?: boolean,
    public onReorder?: (previousIndex: number, currentIndex: number, data: any[]) => void,
    public onSortChange?: (orderBy: OrderByDto[]) => void,
    public hideButtonBar?: boolean,
    public onCustomizeColumns?: () => void,
    public onAllSelected?: (allSelected: boolean) => void,
    public disableSelect?: (row: any) => boolean, // if function returns true, the select checkbox for the row will be disabled
  ) {}
}

export interface TableSelectOption {
  label: string;
  labelParams?: any;
  value: any;
}
